// extracted by mini-css-extract-plugin
module.exports = {"reminder":"ReminderManagerModal_reminder__1Bqn4","modal":"ReminderManagerModal_modal__18lzx","button":"ReminderManagerModal_button__3SD-E"};